export const LIST_INTAKE_REQ = "LIST_INTAKE_REQ";
export const LIST_INTAKE_SUCCESS = "LIST_INTAKE_SUCCESS";
export const LIST_INTAKE_FAILED = "LIST_INTAKE_FAILED";
